"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("@emotion/react");

var _theme = _interopRequireDefault(require("../../theme/theme"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Chip = function Chip(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title,
      onClick = _ref.onClick;
  var heightEx = "".concat(_theme["default"].fontSizeM, " * ").concat(_theme["default"].lineHeightS, " + 2 * ").concat(_theme["default"].spaceHalf, " + 2 * ").concat(_theme["default"].borderSizeRegular);
  var interactive = onClick && typeof onClick === 'function';
  return (0, _react.jsx)("span", {
    className: className,
    css: (0, _react.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        display: inline-flex;\n        box-sizing: border-box;\n        height: calc(", ");\n        padding: ", " ", ";\n\n        border: ", " solid;\n        border-radius: calc(", " / 2);\n\n        background: ", ";\n\n        text-align: center;\n        white-space: nowrap;\n        color: ", ";\n        line-height: ", ";\n        font-size: ", ";\n        font-family: ", ";\n\n        cursor: default;\n        user-select: none;\n\n        @media (hover: hover) {\n          &:hover {\n            filter: brightness(1.2);\n          }\n        }\n        \n        ", "\n        \n        &:nth-of-type(n + 2) {\n          margin-left: ", ";\n        }\n      "])), heightEx, _theme["default"].spaceHalf, _theme["default"].spaceThreeQuarters, _theme["default"].borderSizeRegular, heightEx, _theme["default"].colorThemeTemp, _theme["default"].colorDarkTemp, _theme["default"].lineHeightS, _theme["default"].fontSizeM, _theme["default"].fontFamily, interactive ? "&:active {\n            filter: contrast(0.8);\n            transform: translateY(1px);\n          }" : '', _theme["default"].spaceHalf),
    onClick: onClick,
    title: title
  }, (0, _react.jsx)("span", {
    css: (0, _react.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          display: block;\n          max-width: 45ex;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        "])))
  }, children));
};

Chip.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  title: _propTypes["default"].string,
  onClick: _propTypes["default"].func
};
var _default = Chip;
exports["default"] = _default;